import useRefundToolSearchForm from "./UseRefundToolSearchForm";

import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import Input from "@usas/ui-web/components/inputs/Input";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

const RefundToolSearchForm = ({ onSubmitFormCallback, onClearSearchClicked }) => {
  const {
    formState,
    errorState,
    updateFormState,
    onClearClicked,
    handleSubmit
  } = useRefundToolSearchForm(onSubmitFormCallback, onClearSearchClicked);

  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Input
            label="Receipt Number*"
            name="receiptNumber"
            value={formState.receiptNumber}
            error={errorState.receiptNumber}
            message={errorState.receiptNumber}
            onChange={(value) => { updateFormState('receiptNumber', value); }} />
        </div>
      </div>
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12 usas-extra-top-margin">
          <PrimaryButton type="submit">Search</PrimaryButton>&nbsp;
          {formState.receiptNumber &&
            <SecondaryButton type='button' onClick={() => onClearClicked()}>Clear</SecondaryButton>
          }
        </div>
      </div>
    </form>
  );
};

export default RefundToolSearchForm;